import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TPLink from 'components/TP-UI/TPLink';
import { createPendingSelector } from 'modules/api/selectors';
import TPProgressBar from 'components/TP-UI/TPProgressBar';
import { SMS_EXPIRATION_TIME_MS, SMS_VERIFICATION_TYPE } from '../constants';
import formatMsToTime from '../helpers/formatMsToTime';
import getSeconds from '../helpers/getSeconds';
import PropTypes from 'prop-types';
import { getSmsSentAt } from '../selectors';
import { sendSmsVerificationRequest } from '../actions';

const SendSmsContainer = ({
  label,
  timerLabel = '',
  allowResend,
  delay = SMS_EXPIRATION_TIME_MS,
  type = SMS_VERIFICATION_TYPE.MFA,
  onCodeSent,
  onExpire,
}) => {
  const dispatch = useDispatch();
  const pending = useSelector(createPendingSelector(sendSmsVerificationRequest));
  const smsSentAt = useSelector((state) => getSmsSentAt(state, type));
  const [time, setTime] = useState(-1);

  useEffect(() => {
    let interval = null;
    if (time > 0) {
      interval = setInterval(() => {
        const t = time - 1000;
        setTime(t >= 0 ? t : 0);
      }, 1000);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [time]);

  useEffect(() => {
    if (smsSentAt) {
      const diff = new Date().getTime() - new Date(smsSentAt).getTime();
      if (diff <= delay) {
        setTime(delay - diff);
      }
    }
  }, [smsSentAt, delay]);

  useEffect(() => {
    if (time === 0 && onExpire) {
      onExpire();
    }
  }, [time, onExpire]);

  const handleSendSmsMfa = useCallback(
    (e) => {
      e.preventDefault();
      if (onCodeSent) {
        onCodeSent();
      }
      dispatch(sendSmsVerificationRequest({ type }));
    },
    [dispatch, onCodeSent, type],
  );
  const perc = 100 - Math.floor((getSeconds(time) / getSeconds(delay)) * 100);

  return time > 0 ? (
    <TPProgressBar progress={perc} label={timerLabel + ' ' + formatMsToTime(time)} />
  ) : allowResend ? (
    <TPLink onClick={handleSendSmsMfa} disabled={pending || time > 0}>
      {label}
    </TPLink>
  ) : null;
};

SendSmsContainer.propTypes = {
  label: PropTypes.string,
  timerLabel: PropTypes.string,
  allowResend: PropTypes.bool,
  delay: PropTypes.number,
  type: PropTypes.string,
  onCodeSent: PropTypes.func,
  onExpire: PropTypes.func,
};

export default SendSmsContainer;
